import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import {
  DirectusWhatsNewQuery,
  DirectusWhatsNewQueryVariables,
} from '../../../../../cms-access/gql-types/directus/graphql';
import { DIRECTUS_WHATS_NEW } from '../../../../../cms-access/queries/what-new';
import { cmsClient } from '../../../../../utils/clients/cms-client';
import { isLocalApp } from '../../../../../utils/helpers/local-app';

export const useWhatsNew = () => {
  const { i18n } = useTranslation();
  const { data } = useQuery<DirectusWhatsNewQuery, DirectusWhatsNewQueryVariables>(DIRECTUS_WHATS_NEW, {
    fetchPolicy: 'no-cache',
    variables: { code: i18n.language },
    skip: isLocalApp,
    client: cmsClient,
  });

  const whatsNewData =
    data?.whats_new
      .map((item) => {
        const translations = item.whats_new_translations;

        return {
          id: item.id,
          name: item.friendly_name,
          title: translations && translations.length && translations[0] ? translations[0].title : '',
        };
      })
      .filter((item) => item.title) || [];

  return { whatsNewData };
};
